class BookmarkConfigurator {

  constructor(section) {

    this.section = section;

    this.selectedCharms = new Map();

    this.product = null;
    this.productVariants = [];

    this.currentVariant = null;
    this.currentColour = null;

    this.charmModalEscapeHandler = null;

    this.charms = Array.from(
      this.section.querySelectorAll(
        '[data-charm], .charm-option'
      )
    );

    this.summary =
      this.section.querySelector('[data-summary]');

    this.totalElement =
      this.section.querySelector('[data-total]');

    this.errorElement =
      this.section.querySelector('[data-error]');

    this.addButton =
      this.section.querySelector('[data-add-to-cart]');

    this.addButtonText =
      this.section.querySelector('[data-add-to-cart-text]');

    this.loadingElement =
      this.section.querySelector('[data-loading]');

    this.selectedColourElement =
      this.section.querySelector(
        '[id^="BookmarkSelectedColour-"]'
      );

    this.bindEvents();

    this.moveVariantPicker();

    this.loadProduct();
  }


  /* ============================================================
     LOAD PRODUCT
  ============================================================ */

  async loadProduct() {

    const pathParts =
      window.location.pathname
        .split('/')
        .filter(Boolean);

    const productsIndex =
      pathParts.indexOf('products');

    if (productsIndex === -1) {

      console.error(
        'Bookmark Configurator: Could not determine product handle.'
      );

      return;
    }

    const productHandle =
      pathParts[productsIndex + 1];

    if (!productHandle) {

      console.error(
        'Bookmark Configurator: Product handle not found.'
      );

      return;
    }

    console.log(
      'Bookmark Configurator: Loading product:',
      productHandle
    );

    try {

      const response =
        await fetch(
          `${window.Shopify.routes.root}products/${productHandle}.js`
        );

      if (!response.ok) {

        throw new Error(
          `Product request returned ${response.status}`
        );
      }

      this.product =
        await response.json();

      this.productVariants =
        this.product.variants || [];

      console.log(
        'Bookmark Configurator: Product loaded:',
        this.product
      );

      console.log(
        'Bookmark Configurator: Available variant IDs:',
        this.productVariants.map(
          variant => variant.id
        )
      );

      /*
       * Process whichever colour is currently selected.
       */
      this.variantChanged();

    } catch (error) {

      console.error(
        'Bookmark Configurator: Failed to load product:',
        error
      );
    }
  }


  /* ============================================================
     EVENTS
  ============================================================ */

  bindEvents() {

    /*
     * CHARM IMAGE MODAL
     *
     * Clicking an image inside a charm card opens
     * the image in a near-fullscreen modal.
     */
    this.section.addEventListener(
      'click',
      (event) => {

        const image =
          event.target.closest(
            '.charm-option img'
          );

        if (!image) {

          return;

        }

        /*
         * Don't interfere with buttons or controls
         * if the image happens to be inside one.
         */
        if (
          event.target.closest(
            'button, a, [data-quantity-plus], [data-quantity-minus], .charm-add'
          )
        ) {

          return;

        }

        event.preventDefault();

        this.openCharmImageModal(
          image.currentSrc ||
          image.src
        );

      }
    );


    /*
     * Charm buttons.
     */
    this.section.addEventListener(
      'click',
      (event) => {

        const plusButton =
          event.target.closest(
            '[data-quantity-plus]'
          );

        const minusButton =
          event.target.closest(
            '[data-quantity-minus]'
          );


        /*
         * PLUS
         */
        if (plusButton) {

          const card =
            plusButton.closest(
              '.charm-option'
            );

          if (!card) return;

          const inventory =
            Number(
              card.dataset.inventory || 0
            );

          const quantityElement =
            card.querySelector(
              '[data-quantity]'
            );

          const currentQuantity =
            quantityElement
              ? Number(
                  quantityElement.textContent || 0
                )
              : 0;


          /*
           * Do not allow the user to exceed
           * the available inventory.
           */
          if (
            inventory <= 0 ||
            currentQuantity >= inventory
          ) {

            plusButton.disabled = true;

            return;
          }


          /*
           * Increase the quantity.
           */
          this.changeCharmQuantity(
            Number(
              plusButton.dataset.variantId
            ),
            1
          );


          /*
           * Update the + button after the
           * quantity has changed.
           */
          const newQuantity =
            currentQuantity + 1;

          plusButton.disabled =
            newQuantity >= inventory;

          return;
        }


        /*
         * MINUS
         */
        if (minusButton) {

          const card =
            minusButton.closest(
              '.charm-option'
            );

          if (!card) return;

          this.changeCharmQuantity(
            Number(
              minusButton.dataset.variantId
            ),
            -1
          );


          /*
           * Re-enable + after reducing
           * the quantity below the stock limit.
           */
          const inventory =
            Number(
              card.dataset.inventory || 0
            );

          const quantityElement =
            card.querySelector(
              '[data-quantity]'
            );

          const newQuantity =
            quantityElement
              ? Number(
                  quantityElement.textContent || 0
                )
              : 0;

          const cardPlusButton =
            card.querySelector(
              '[data-quantity-plus]'
            );

          if (cardPlusButton) {

            cardPlusButton.disabled =
              newQuantity >= inventory;

          }

          return;
        }


        /*
         * ADD BUTTON
         *
         * Your original Liquid uses .charm-add.
         */
        const addButton =
          event.target.closest(
            '.charm-add'
          );

        if (addButton) {

          event.preventDefault();

          this.changeCharmQuantity(
            Number(
              addButton.dataset.variantId
            ),
            1
          );

          return;
        }

      }
    );


    /*
     * Add bookmark + charms to cart.
     */
    if (this.addButton) {

      this.addButton.addEventListener(
        'click',
        () => {

          this.addConfigurationToCart();

        }
      );
    }


    /*
     * Dawn colour inputs.
     */
    document.addEventListener(
      'change',
      (event) => {

        const colourInput =
          event.target.closest(
            'input[type="radio"][name^="Color-"][data-variant-id]'
          );

        if (!colourInput) {

          return;

        }


        const colour =
          String(
            colourInput.value || ''
          )
            .trim()
            .toLowerCase();


        if (
          colour !== 'gold' &&
          colour !== 'silver'
        ) {

          return;

        }


        console.log(
          'Bookmark Configurator: Color changed:',
          colour
        );


        console.log(
          'Bookmark Configurator: Dawn variant ID:',
          colourInput.dataset.variantId
        );


        /*
         * Give Dawn time to finish its own variant update.
         */
        setTimeout(
          () => {

            this.variantChanged();

          },
          100
        );

      }
    );
  }


  /* ============================================================
     FIND CURRENT DAWN COLOUR
  ============================================================ */

  getCurrentColourInput() {

    const colourInput =
      document.querySelector(
        'input[type="radio"][name^="Color-"][data-variant-id]:checked'
      );

    return colourInput;
  }


  /* ============================================================
     MOVE DAWN VARIANT PICKER INTO CONFIGURATOR
  ============================================================ */

  moveVariantPicker() {

    const target =
      this.section.querySelector(
        '[data-bookmark-variant-picker]'
      );

    if (!target) {

      console.warn(
        'Bookmark Configurator: Variant picker target not found.'
      );

      return;
    }


    const variantPicker =
      document.querySelector(
        'variant-picker[data-product-id]'
      );

    if (!variantPicker) {

      console.warn(
        'Bookmark Configurator: Dawn variant picker not found.'
      );

      return;
    }


    /*
     * Already moved.
     */
    if (
      target.contains(
        variantPicker
      )
    ) {

      return;
    }


    console.log(
      'Bookmark Configurator: Moving Dawn variant picker into configurator.'
    );


    target.appendChild(
      variantPicker
    );
  }


  /* ============================================================
     VARIANT CHANGED
  ============================================================ */

  variantChanged() {

    /*
     * Product must have loaded.
     */
    if (!this.productVariants.length) {

      console.log(
        'Bookmark Configurator: Waiting for product variants...'
      );

      return;
    }


    /*
     * Find the checked Gold/Silver radio.
     */
    const colourInput =
      this.getCurrentColourInput();


    if (!colourInput) {

      console.warn(
        'Bookmark Configurator: Could not find checked Color input.'
      );

      return;
    }


    /*
     * Get Gold/Silver.
     */
    const selectedColour =
      String(
        colourInput.value || ''
      )
        .trim()
        .toLowerCase();


    /*
     * Get Shopify variant ID directly from Dawn.
     */
    const variantId =
      Number(
        colourInput.dataset.variantId
      );


    console.log(
      'Bookmark Configurator: Checked Color:',
      selectedColour
    );


    console.log(
      'Bookmark Configurator: Checked variant ID:',
      variantId
    );


    if (!variantId) {

      console.error(
        'Bookmark Configurator: No variant ID found on selected Color.'
      );

      return;
    }


    /*
     * Find matching variant in Shopify product JSON.
     */
    const newVariant =
      this.productVariants.find(
        variant => {

          return (
            Number(variant.id) ===
            variantId
          );

        }
      );


    if (!newVariant) {

      console.error(
        'Bookmark Configurator: Shopify variant not found:',
        variantId
      );


      console.log(
        'Available variants:',
        this.productVariants.map(
          variant => ({
            id: variant.id,
            title: variant.title,
            option1: variant.option1,
            featuredImage:
              variant.featured_image
                ? variant.featured_image.src
                : null
          })
        )
      );

      return;
    }


    /*
     * Save current variant.
     */
    this.currentVariant =
      newVariant;


    this.currentColour =
      selectedColour;


    console.log(
      'Bookmark Configurator: currentColour set to:',
      this.currentColour
    );


    console.log(
      'Bookmark Configurator: Selected bookmark variant:',
      newVariant
    );


    console.log(
      'Bookmark Configurator: Current colour:',
      this.currentColour
    );


    /*
     * NEW:
     *
     * Change the main product image to the
     * image assigned to the selected Shopify variant.
     */
    this.updateProductMainImage(
      newVariant
    );


    /*
     * Update finish text.
     */
    this.updateColour();


    /*
     * Remove charms that don't match.
     */
    this.clearIncompatibleCharms();


    /*
     * Show correct charms.
     */
    this.updateCharms();


    /*
     * Update summary.
     */
    this.updateSummary();
  }


  /* ============================================================
     UPDATE MAIN PRODUCT IMAGE
  ============================================================ */

  updateProductMainImage(
    variant
  ) {

    if (!variant) {

      return;

    }


    /*
     * Shopify's product JSON provides the image
     * associated with the variant here.
     *
     * Example:
     *
     * variant.featured_image = {
     *   id: 123456,
     *   src: "..."
     * }
     */
    const featuredImage =
      variant.featured_image;


    if (!featuredImage) {

      console.warn(
        'Bookmark Configurator: Selected variant has no featured image:',
        variant.id
      );

      return;
    }


    const mediaId =
      Number(
        featuredImage.id
      );


    const imageSrc =
      featuredImage.src;


    console.log(
      'Bookmark Configurator: Updating product image:',
      {
        variantId: variant.id,
        mediaId: mediaId,
        imageSrc: imageSrc
      }
    );


    /*
     * FIRST:
     *
     * Try to find the existing Shopify media item
     * using the data-media-id from product-media.liquid.
     */
    if (mediaId) {

      const mediaElement =
        document.querySelector(
          `.product-media[data-media-id="${mediaId}"]`
        );


      if (mediaElement) {

        console.log(
          'Bookmark Configurator: Found matching product media:',
          mediaElement
        );


        /*
         * Find a clickable gallery control associated
         * with this media.
         */
        const mediaControl =
          document.querySelector(
            `[data-media-id="${mediaId}"] button:not(.deferred-media__poster-button), ` +
            `[data-media-id="${mediaId}"][role="tab"], ` +
            `button[data-media-id="${mediaId}"], ` +
            `[data-target-media-id="${mediaId}"]`
          );


        if (mediaControl) {

          console.log(
            'Bookmark Configurator: Selecting matching gallery media.'
          );


          mediaControl.click();

          return;
        }


        /*
         * If there isn't a clickable thumbnail/control,
         * try to make the matching media active.
         */
        const mediaContainer =
          mediaElement.closest(
            '.product-media-container, [data-media-id]'
          );


        if (mediaContainer) {

          /*
           * Remove common hidden/inactive states.
           */
          mediaContainer.removeAttribute(
            'hidden'
          );

          mediaContainer.classList.add(
            'is-active'
          );

        }


        /*
         * Scroll the matching image into view on
         * galleries that use normal scrolling.
         */
        if (
          typeof mediaElement.scrollIntoView ===
          'function'
        ) {

          mediaElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });

        }


        return;
      }

    }


    /*
     * FALLBACK:
     *
     * If we can't find the media ID in the gallery,
     * update the currently visible product image
     * directly using the variant image.
     */
    if (imageSrc) {

      this.updateVisibleProductImage(
        imageSrc
      );

    }

  }


  /* ============================================================
     FALLBACK PRODUCT IMAGE UPDATE
  ============================================================ */

  updateVisibleProductImage(
    imageSrc
  ) {

    if (!imageSrc) {

      return;

    }


    /*
     * Find the visible product media image.
     */
    const productImages =
      Array.from(
        document.querySelectorAll(
          '.product-media__image'
        )
      );


    if (!productImages.length) {

      console.warn(
        'Bookmark Configurator: Could not find product gallery images.'
      );

      return;
    }


    /*
     * Prefer an image that is currently visible.
     */
    let visibleImage =
      productImages.find(
        image => {

          const style =
            window.getComputedStyle(
              image
            );

          return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            image.offsetWidth > 0 &&
            image.offsetHeight > 0
          );

        }
      );


    /*
     * Otherwise use the first product image.
     */
    if (!visibleImage) {

      visibleImage =
        productImages[0];

    }


    /*
     * Update the image.
     */
    visibleImage.src =
      imageSrc;


    /*
     * Also update srcset so responsive images
     * don't immediately replace our image.
     */
    if (
      visibleImage.hasAttribute(
        'srcset'
      )
    ) {

      visibleImage.removeAttribute(
        'srcset'
      );

    }


    visibleImage.setAttribute(
      'data-bookmark-variant-image',
      imageSrc
    );


    console.log(
      'Bookmark Configurator: Updated visible product image using fallback.'
    );

  }


  /* ============================================================
     UPDATE COLOUR
  ============================================================ */

  updateColour() {

    if (!this.selectedColourElement) {

      return;
    }


    if (this.currentColour) {

      this.selectedColourElement.textContent =
        this.capitalize(
          this.currentColour
        );

    } else {

      this.selectedColourElement.textContent =
        'Select a finish above';

    }
  }


  /* ============================================================
     SHOW / HIDE CHARMS
  ============================================================ */

  updateCharms() {

    const colourInput =
      this.getCurrentColourInput();


    if (!colourInput) {

      console.warn(
        'Bookmark Configurator: No selected colour input found.'
      );

      return;
    }


    const selectedColour =
      String(
        colourInput.value || ''
      )
        .trim()
        .toLowerCase();


    console.log(
      'Bookmark Configurator: Filtering charms for:',
      selectedColour
    );


    this.charms.forEach(
      charm => {

        const charmColour =
          String(
            charm.dataset.colour || ''
          )
            .trim()
            .toLowerCase();


        const available =
          charm.dataset.available ===
          'true';


        const shouldShow =
          charmColour ===
          selectedColour &&
          available;


        console.log(
          'Charm:',
          charm.querySelector('h4')?.textContent.trim(),
          '| colour:',
          charmColour,
          '| selected:',
          selectedColour,
          '| available:',
          available,
          '| visible:',
          shouldShow
        );


        /*
         * Explicitly control display.
         *
         * !important is used because your theme CSS
         * may be setting display on .charm-option.
         */
        if (shouldShow) {

          charm.style.setProperty(
            'display',
            '',
            'important'
          );

          charm.removeAttribute(
            'hidden'
          );

        } else {

          charm.style.setProperty(
            'display',
            'none',
            'important'
          );

          charm.setAttribute(
            'hidden',
            ''
          );

        }

      }
    );
  }


  /* ============================================================
     CLEAR WRONG COLOUR CHARMS
  ============================================================ */

  clearIncompatibleCharms() {

    if (!this.currentColour) {

      return;
    }


    this.charms.forEach(
      charm => {

        const charmColour =
          String(
            charm.dataset.colour || ''
          )
            .trim()
            .toLowerCase();


        if (
          charmColour !==
          this.currentColour
        ) {

          const variantId =
            Number(
              charm.dataset.variantId
            );


          if (
            this.selectedCharms.has(
              variantId
            )
          ) {

            this.selectedCharms.delete(
              variantId
            );


            this.updateQuantityDisplay(
              variantId,
              0
            );

          }

        }

      }
    );
  }


  /* ============================================================
     CHANGE CHARM QUANTITY
  ============================================================ */

  changeCharmQuantity(
    variantId,
    change
  ) {

    if (!this.currentColour) {

      this.showError(
        'Please select Gold or Silver first.'
      );

      return;
    }


    const charm =
      this.charms.find(
        item =>
          Number(
            item.dataset.variantId
          ) ===
          Number(variantId)
      );


    if (!charm) {

      console.warn(
        'Bookmark Configurator: Charm not found:',
        variantId
      );

      return;
    }


    const charmColour =
      String(
        charm.dataset.colour || ''
      )
        .trim()
        .toLowerCase();


    if (
      charmColour !==
      this.currentColour
    ) {

      return;
    }


    if (
      charm.dataset.available !==
      'true'
    ) {

      return;
    }


    const oldQuantity =
      this.selectedCharms.get(
        Number(variantId)
      ) || 0;


    const newQuantity =
      Math.max(
        0,
        oldQuantity + change
      );


    if (
      newQuantity === 0
    ) {

      this.selectedCharms.delete(
        Number(variantId)
      );

    } else {

      this.selectedCharms.set(
        Number(variantId),
        newQuantity
      );

    }


    this.updateQuantityDisplay(
      variantId,
      newQuantity
    );


    this.updateSummary();
  }


  /* ============================================================
     QUANTITY DISPLAY
  ============================================================ */

  updateQuantityDisplay(
    variantId,
    quantity
  ) {

    const quantityElement =
      this.section.querySelector(
        `[data-quantity][data-variant-id="${variantId}"]`
      );


    if (quantityElement) {

      quantityElement.textContent =
        quantity;

    }


    /*
     * ADD BUTTON
     */
    const addButton =
      this.section.querySelector(
        `.charm-add[data-variant-id="${variantId}"]`
      );


    if (addButton) {

      if (quantity > 0) {

        addButton.textContent =
          `Added (${quantity})`;

        addButton.classList.add(
          'is-added'
        );

      } else {

        addButton.textContent =
          'Add';

        addButton.classList.remove(
          'is-added'
        );

      }

    }


    /*
     * QUANTITY CONTROLS
     */
    const quantityControls =
      this.section.querySelector(
        `[data-quantity-controls][data-variant-id="${variantId}"]`
      );


    if (quantityControls) {

      if (quantity > 0) {

        quantityControls.style.display =
          'flex';

      } else {

        quantityControls.style.display =
          'none';

      }

    }


    /*
     * SELECTED CARD
     */
    const charmCard =
      this.charms.find(
        item =>
          Number(
            item.dataset.variantId
          ) ===
          Number(variantId)
      );


    if (charmCard) {

      if (quantity > 0) {

        charmCard.classList.add(
          'is-selected'
        );

      } else {

        charmCard.classList.remove(
          'is-selected'
        );

      }

    }

  }


  /* ============================================================
     SUMMARY
  ============================================================ */

  updateSummary() {

    if (!this.summary) {

      return;
    }


    this.summary.innerHTML =
      '';


    let total =
      0;


    /*
     * Bookmark.
     */
    if (this.currentVariant) {

      const bookmarkRow =
        document.createElement(
          'div'
        );


      bookmarkRow.className =
        'bookmark-configurator__summary-row';


      const bookmarkName =
        this.currentVariant.name ||
        `Bookmark - ${this.capitalize(
          this.currentColour
        )}`;


      bookmarkRow.innerHTML = `
        <span>
          ${this.escapeHtml(bookmarkName)}
        </span>

        <strong>
          ${this.formatMoney(
            this.currentVariant.price
          )}
        </strong>
      `;


      this.summary.appendChild(
        bookmarkRow
      );


      total +=
        Number(
          this.currentVariant.price
        );

    }


    /*
     * Charms.
     */
    this.selectedCharms.forEach(
      (quantity, variantId) => {

        const charm =
          this.charms.find(
            item =>
              Number(
                item.dataset.variantId
              ) ===
              Number(variantId)
          );


        if (!charm) {

          return;
        }


        const price =
          Number(
            charm.dataset.price || 0
          );


        total +=
          price * quantity;


        const titleElement =
          charm.querySelector(
            '.bookmark-charm__title, h4, [data-charm-title]'
          );


        const title =
          titleElement
            ? titleElement.textContent.trim()
            : 'Charm';


        const row =
          document.createElement(
            'div'
          );


        row.className =
          'bookmark-configurator__summary-row';


        row.innerHTML = `
          <span>
            ${this.escapeHtml(title)}
            × ${quantity}
          </span>

          <strong>
            ${this.formatMoney(
              price * quantity
            )}
          </strong>
        `;


        this.summary.appendChild(
          row
        );

      }
    );


    if (
      this.totalElement
    ) {

      this.totalElement.textContent =
        this.formatMoney(
          total
        );

    }

  }


  /* ============================================================
     ADD TO CART
  ============================================================ */

  async addConfigurationToCart() {

    this.hideError();


    if (!this.currentVariant) {

      this.showError(
        'Please select Gold or Silver.'
      );

      return;
    }


    const items = [

      {
        id:
          Number(
            this.currentVariant.id
          ),

        quantity:
          1
      }

    ];


    this.selectedCharms.forEach(
      (quantity, variantId) => {

        if (
          quantity > 0
        ) {

          items.push({

            id:
              Number(
                variantId
              ),

            quantity:
              quantity

          });

        }

      }
    );


    console.log(
      'Bookmark Configurator: Adding to cart:',
      items
    );


    this.setLoading(
      true
    );


    try {

      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              'Accept':
                'application/json'

            },

            body:
              JSON.stringify({

                items:
                  items,

                sections:
                  'cart-drawer,cart-icon-bubble',

                sections_url:
                  window.location.pathname

              })

          }
        );


      const data =
        await response.json();


      if (
        !response.ok
      ) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add products to cart.'
        );

      }


      console.log(
        'Bookmark Configurator: Added to cart:',
        data
      );


      this.updateCartDrawer();


      /*
       * Reset charms.
       */
      this.selectedCharms.clear();


      this.charms.forEach(
        charm => {

          this.updateQuantityDisplay(
            charm.dataset.variantId,
            0
          );

        }
      );


      this.updateSummary();


    } catch (error) {

      console.error(
        'Bookmark Configurator: Cart error:',
        error
      );


      this.showError(
        error.message ||
        'There was a problem adding the items to your cart.'
      );


    } finally {

      this.setLoading(
        false
      );

    }

  }


  /* ============================================================
     UPDATE CART DRAWER
  ============================================================ */

  updateCartDrawer() {

    console.log(
      'Bookmark Configurator: Updating Dawn cart drawer...'
    );


    const cartDrawer =
      document.querySelector(
        'cart-drawer-component'
      );


    if (!cartDrawer) {

      console.warn(
        'Bookmark Configurator: cart-drawer-component not found.'
      );

      return;

    }


    console.log(
      'Bookmark Configurator: Found cart drawer component:',
      cartDrawer
    );


    fetch(
      `${window.Shopify.routes.root}cart.js`
    )
      .then(
        response => {

          if (!response.ok) {

            throw new Error(
              'Unable to fetch updated cart.'
            );

          }

          return response.json();

        }
      )
      .then(
        cart => {

          console.log(
            'Bookmark Configurator: Updated cart:',
            cart
          );


          return import('@theme/events')
            .then(
              ({ CartUpdateEvent }) => {

                console.log(
                  'Bookmark Configurator: Dispatching CartUpdateEvent.'
                );


                const event =
                  new CartUpdateEvent(
                    cart,
                    'bookmark-configurator',
                    {
                      itemCount:
                        cart.item_count,

                      source:
                        'bookmark-configurator',

                      sections:
                        {}

                    }
                  );


                document.dispatchEvent(
                  event
                );

              }
            )
            .catch(
              error => {

                console.warn(
                  'Bookmark Configurator: Could not load @theme/events:',
                  error
                );

              }
            );

        }
      )
      .then(
        () => {

          setTimeout(
            () => {

              console.log(
                'Bookmark Configurator: Opening cart drawer.'
              );


              cartDrawer.open();

            },
            150
          );

        }
      )
      .catch(
        error => {

          console.error(
            'Bookmark Configurator: Failed to update cart drawer:',
            error
          );


          cartDrawer.open();

        }
      );

  }


  /* ============================================================
     OPEN CART DRAWER
  ============================================================ */

  openCartDrawer() {

    console.log(
      'Bookmark Configurator: Opening Dawn cart drawer...'
    );


    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (cartDrawer) {

      console.log(
        'Bookmark Configurator: Found cart drawer:',
        cartDrawer
      );


      setTimeout(
        () => {

          if (
            typeof cartDrawer.open ===
            'function'
          ) {

            cartDrawer.open();

            console.log(
              'Bookmark Configurator: Cart drawer opened.'
            );

          } else {

            console.warn(
              'Bookmark Configurator: cartDrawer.open() is not available.'
            );

          }

        },
        100
      );


      return;

    }


    const cartDrawerComponent =
      document.querySelector(
        'cart-drawer-component'
      );


    if (cartDrawerComponent) {

      console.log(
        'Bookmark Configurator: Found cart drawer component:',
        cartDrawerComponent
      );


      setTimeout(
        () => {

          if (
            typeof cartDrawerComponent.open ===
            'function'
          ) {

            cartDrawerComponent.open();

          }

        },
        100
      );


      return;

    }


    console.warn(
      'Bookmark Configurator: Could not find Dawn cart drawer. Going to cart page.'
    );


    window.location.href =
      `${window.Shopify.routes.root}cart`;

  }


  /* ============================================================
     CHARM IMAGE MODAL
  ============================================================ */

  openCharmImageModal(
    imageSrc
  ) {

    if (!imageSrc) {

      return;

    }


    /*
     * Remove an existing modal first.
     */
    const existingModal =
      document.querySelector(
        '[data-charm-image-modal]'
      );


    if (existingModal) {

      existingModal.remove();

    }


    /*
     * Create modal.
     */
    const modal =
      document.createElement(
        'div'
      );


    modal.setAttribute(
      'data-charm-image-modal',
      ''
    );


    modal.className =
      'bookmark-charm-image-modal';


    /*
     * Modal HTML.
     */
    modal.innerHTML = `
      <div
        class="bookmark-charm-image-modal__backdrop"
        data-charm-modal-close
      ></div>

      <div
        class="bookmark-charm-image-modal__content"
        role="dialog"
        aria-modal="true"
        aria-label="Charm image preview"
      >

        <button
          type="button"
          class="bookmark-charm-image-modal__close"
          data-charm-modal-close
          aria-label="Close image preview"
        >
          &times;
        </button>

        <img
          src="${this.escapeHtml(imageSrc)}"
          class="bookmark-charm-image-modal__image"
          alt="Charm preview"
        >

      </div>
    `;


    document.body.appendChild(
      modal
    );


    /*
     * Prevent the page behind the modal
     * from scrolling.
     */
    document.body.classList.add(
      'charm-image-modal-open'
    );


    /*
     * Close button / backdrop.
     */
    modal.addEventListener(
      'click',
      (event) => {

        if (
          event.target.closest(
            '[data-charm-modal-close]'
          )
        ) {

          this.closeCharmImageModal();

        }

      }
    );


    /*
     * Escape key.
     */
    this.charmModalEscapeHandler =
      (event) => {

        if (
          event.key === 'Escape'
        ) {

          this.closeCharmImageModal();

        }

      };


    document.addEventListener(
      'keydown',
      this.charmModalEscapeHandler
    );


    /*
     * Small delay allows the opening
     * animation to run.
     */
    requestAnimationFrame(
      () => {

        modal.classList.add(
          'is-open'
        );

      }
    );

  }


  /* ============================================================
     CLOSE CHARM IMAGE MODAL
  ============================================================ */

  closeCharmImageModal() {

    const modal =
      document.querySelector(
        '[data-charm-image-modal]'
      );


    if (!modal) {

      return;

    }


    modal.classList.remove(
      'is-open'
    );


    document.body.classList.remove(
      'charm-image-modal-open'
    );


    if (
      this.charmModalEscapeHandler
    ) {

      document.removeEventListener(
        'keydown',
        this.charmModalEscapeHandler
      );


      this.charmModalEscapeHandler =
        null;

    }


    setTimeout(
      () => {

        if (
          modal.parentNode
        ) {

          modal.remove();

        }

      },
      200
    );

  }


  /* ============================================================
     LOADING
  ============================================================ */

  setLoading(
    isLoading
  ) {

    if (
      this.addButton
    ) {

      this.addButton.disabled =
        isLoading;

    }


    if (
      this.addButtonText
    ) {

      this.addButtonText.hidden =
        isLoading;

    }


    if (
      this.loadingElement
    ) {

      this.loadingElement.hidden =
        !isLoading;

    }

  }


  /* ============================================================
     ERRORS
  ============================================================ */

  showError(
    message
  ) {

    if (!this.errorElement) {

      console.error(
        message
      );

      return;
    }


    this.errorElement.textContent =
      message;


    this.errorElement.hidden =
      false;

  }


  hideError() {

    if (!this.errorElement) {

      return;
    }


    this.errorElement.textContent =
      '';


    this.errorElement.hidden =
      true;

  }


  /* ============================================================
     MONEY
  ============================================================ */

  formatMoney(
    cents
  ) {

    const currency =
      window.Shopify?.currency?.active ||
      'GBP';


    return new Intl.NumberFormat(
      document.documentElement.lang ||
      'en-GB',
      {

        style:
          'currency',

        currency:
          currency

      }
    ).format(
      Number(cents) / 100
    );

  }


  /* ============================================================
     CAPITALIZE
  ============================================================ */

  capitalize(
    value
  ) {

    if (!value) {

      return '';

    }


    return (
      value.charAt(0).toUpperCase() +
      value.slice(1)
    );

  }


  /* ============================================================
     ESCAPE HTML
  ============================================================ */

  escapeHtml(
    value
  ) {

    const div =
      document.createElement(
        'div'
      );


    div.textContent =
      value;


    return div.innerHTML;

  }

}


/* ============================================================
   INITIALISE
============================================================ */

function initialiseBookmarkConfigurators() {

  document
    .querySelectorAll(
      '.bookmark-configurator'
    )
    .forEach(
      section => {

        if (
          section.dataset.initialised ===
          'true'
        ) {

          return;

        }


        section.dataset.initialised =
          'true';


        new BookmarkConfigurator(
          section
        );

      }
    );

}


/* ============================================================
   PAGE LOAD
============================================================ */

document.addEventListener(
  'DOMContentLoaded',
  () => {

    initialiseBookmarkConfigurators();

  }
);


/* ============================================================
   SHOPIFY THEME EDITOR
============================================================ */

document.addEventListener(
  'shopify:section:load',
  event => {

    if (
      event.target.matches(
        '.bookmark-configurator'
      )
    ) {

      event.target.dataset.initialised =
        'false';


      initialiseBookmarkConfigurators();

    }

  }
);
